import React, { Component } from 'react'
import { Form, Icon, Input, Button, Row, Col, Spin, Select,  Checkbox } from 'antd';
const FormItem = Form.Item;
const { Option } = Select;

class SignupflowForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      plan:"free",
      lastName: '',
      email: '',
      password: '',
      role: 'student',
      paymentTokenID:"",
      card:{},
      subscription:{},
      loading: false,
      tos:true,
      current_period_end:null,
      status: {
        completed: false
      }
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleChange(e) {
    if(e.target.name === "tos") return this.setState({[e.target.name]: e.target.checked})

    this.setState({ [e.target.name]: e.target.value });
  }

  handleSelectChange(value) {
    this.setState({ role: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFields((err) => {
      if (!err) {
        console.log('here we go!')
        // this.props.moveStep()
        this.props.signUp(this.state)
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="signupflowcard">
        <Spin tip="Setting up account" spinning={this.props.loading}>
          <Form
          onSubmit={(e) => {
            this.handleSubmit(e);
          }}>
            <Row gutter={8}>
              <Col span={12}>
                <FormItem >
                {getFieldDecorator('firstName', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your first name'
                    }
                  ]
                })(
                  <Input
                    onChange={e => this.handleChange(e)}
                    prefix={
                      <Icon
                        type="user"
                        style={{ color: 'rgba(0,0,0,.25)' }}
                      />
                    }
                    name="firstName"
                    placeholder="First Name"
                  />
                )}
              </FormItem>
              </Col>
              <Col span={12}>
                <FormItem>
                {getFieldDecorator('lastName', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your last name'
                    }
                  ]
                })(
                  <Input
                    onChange={e => this.handleChange(e)}
                    prefix={
                      <Icon
                        type="user"
                        style={{ color: 'rgba(0,0,0,.25)' }}
                      />
                    }
                    name="lastName"
                    placeholder="Last Name"
                  />
                )}
                </FormItem>
              </Col>
            </Row>
            <Form.Item >
              {getFieldDecorator('select', {
                initialValue:"student",
                rules: [
                  { required: true, message: 'Please select your role!' }
                ]
              })(
                <Select onChange={this.handleSelectChange} placeholder="Please select a role">
                  <Option value="student">Student</Option>
                  {/* <Option disabled value="teacher">Teacher</Option> */}
                </Select>
              )}
            </Form.Item>
            <FormItem>
              {getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your email'
                  },
                  {
                    type: 'email',
                    message: 'The input is not valid email'
                  }
                ]
              })(
                <Input
                  onChange={e => this.handleChange(e)}
                  prefix={
                    <Icon
                      type="mail"
                      style={{ color: 'rgba(0,0,0,.25)' }}
                    />
                  }
                  name="email"
                  placeholder="Email"
                />
              )}
            </FormItem>
            <FormItem style={{margin:0}}>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your password'
                  },
                  {
                    min: 6,
                    message: 'Password should be at least 6 characters'
                  }
                ]
              })(
                <Input.Password
                  onChange={e => this.handleChange(e)}
                  prefix={
                    <Icon
                      type="lock"
                      style={{ color: 'rgba(0,0,0,.25)' }}
                    />
                  }
                  name="password"
                  type="password"
                  placeholder="Password"
                />
              )}
            </FormItem>
            <Form.Item style={{margin:0}}>
              {getFieldDecorator('remember', {
                  valuePropName: 'checked',
                  initialValue: true,
              })(<Checkbox name="tos" onChange={e => this.handleChange(e)}>I agree to Terms & Conditions and Privacy Policy</Checkbox>)}
            </Form.Item>
            <FormItem>
              <Button disabled={!this.state.tos} type="primary" htmlType="submit" className="xpad-btn">
                Continue
              </Button>
            </FormItem>
          </Form>
        </Spin>
      </div>
    )
  }
}

const WrappedSignupflowForm = Form.create()(SignupflowForm);
export default WrappedSignupflowForm
